













































































import { Component, Vue, Prop } from "vue-property-decorator";
import { ComposeStudent$, GetAllBanjis$, GetXsDetail$ } from "@/request/jxgl";
import MainHeader from "../../../main/components/main-header/main-header.vue";
import NavLeft from "../../components/left-nav.vue";
@Component({
  components: {
    MainHeader,
    NavLeft,
  },
})
export default class XsDetail extends Vue {
  private xs: any = {
    user_id: "",
    姓名: "",
    学号: "",
    class_id: "",
  };
  private banjis: any[] = [];
  // 获得详情
  private fetchDetail() {
    const params: any = {
      params: {
        user_id: this.$route.query.id,
      },
    };
    GetXsDetail$(this, params).then((data: any) => {
      this.$set(this, "xs", data);
    });
  }
  // 获得班级列表
  private fetchBanji() {
    GetAllBanjis$(this).then((data: any) => {
      this.banjis = data;
    });
  }
  // 取消
  private cancel() {
    this.$router.back();
  }
  // 保存
  private save() {
    if (!this.xs["user_id"]) {
      delete this.xs["user_id"];
    }
    if (!this.xs["姓名"]) {
      this.$message.warning("姓名不能为空");
      return;
    }
    if (!this.xs["学号"]) {
      this.$message.warning("学号不能为空");
      return;
    }
    if (!this.xs["class_id"]) {
      this.$message.warning("所属班级不能为空");
      return;
    }
    // console.log(this.xs);
    ComposeStudent$(this, this.xs).then((data: any) => {
      this.$message.success("编辑成功");
      this.$router.back();
    });
  }
  /**
   * @description 保存并添加下一个
   */
  private saveNext() {
    if (!this.xs["user_id"]) {
      delete this.xs["user_id"];
    }
    if (!this.xs["姓名"]) {
      this.$message.warning("姓名不能为空");
      return;
    }
    if (!this.xs["学号"]) {
      this.$message.warning("学号不能为空");
      return;
    }
    if (!this.xs["class_id"]) {
      this.$message.warning("所属不能为空");
      return;
    }
    // console.log(this.xs);
    ComposeStudent$(this, this.xs).then((data: any) => {
      this.$message.success("编辑成功");
      this.xs.user_id = "";
      this.xs["姓名"] = "";
      this.xs["学号"] = "";
      (this.$refs.xingming as any).focus();
    });
  }
  // 初始化
  private mounted() {
    this.fetchBanji();
    if (this.$route.query.id) {
      this.fetchDetail();
    }
  }
}
